import React, { useEffect, useState } from "react";

//*Mui
import { Modal, Box, Divider } from "@mui/material";

//*redux
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";

//*files
import cssClasses from "./AddPriceList.module.css";
import UpdatePrice from "../../Components/UpdatePrice/UpdatePrice";
import Button from "../../Subcomponents/Button";
import Close from "../../Components/Icons/Close";
import { useParams } from "react-router-dom";
import {
  AddProjectPricing,
  CheckPricingDefault,
  CheckProjectPricingDetails,
  getBasePricingByProjectId,
  getProjectDataByProjectId,
  updateFlagsToProjectTable,
  UpdateProjectPricing,
} from "../../Services/Project";
import {
  getAllWingsByProjectId,
  getInventoryTypeFromProjectName,
  getInventoryTypeFromProjectWing,
  getProjectByProjectName,
  getSelectedWingsByProjectId,
  getWingsByProjectId,
} from "../../Services/SustenanceService";
import _, {
  groupBy,
  merge, sortedUniq,
  uniqBy,
} from "lodash";
import DropDown from "../../Subcomponents/DropDown";
import CustomInput from "../../Subcomponents/CustomInput";
import { infoTost, successTost } from "../../Services/Toast";
import DateComponent from "../../Subcomponents/DateComponent";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomSwitch from "../../Subcomponents/CustomSwitch";
import { getProjectInventory } from "../../Services/Inventory";
import { dismissLoader, presentLoader } from "../../Services/loader";

const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "80%",
  width: "Fit-Content",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

function AddPriceList({ open, handleClose, data, BasePriceResp, ModalType }) {
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const [InventoryData, setInventoryData] = useState([]);
  const [ProjectPricingData, setProjectPricingData] = useState({});
  const [WingsData, setWingsData] = useState([]);
  const [InventoryType, setInventoryType] = useState([]);
  const [ShowFields, setShowFields] = useState(false);
  const [SaveData, setSaveData] = useState(true);
  const [checked, setChecked] = useState(false);

  const [BspButton, setBspButton] = useState(false);
  const [TotalButton, setTotalButton] = useState(false);

  const [priceListShow, setPriceListShow] = useState(false);

  const [priceData, setPriceData] = useState([
    {
      UnitType: '',
      UnitTypeId: '',
      areaOptions: [{
        BSP: "",
        bspType: "",
        BSPTotal: "",
        sqft: '',
        REG: '',
        flag: false,
        OCR: "",
        SDR: "",
        Total: "",
      }],
    }
  ]);

  //*Base-Price
  const [floorsSelected, setFloorsSelected] = useState([]);

  const [BasePriceDetails, setBasePriceDetails] = useState({
    title: "",
    RegPercentage: "",
    StartDate: "",
    EndDate: "",
    Wings: "",
    floorRise: [],
    parking: [],
    // plc: [],
  });
  const [HelperText, setHelperText] = useState({
    title: "",
    RegPercentage: "",
    StartDate: "",
    EndDate: "",
    Wings: "",
    floorRise: [],
    parking: [],
    // plc: [],
  });
  let UnitTypes = [];
  useEffect(() => {
    dispatch(action.activeMenu("project"));
    getProjectDetails();
    getBasePriceDetails();
  }, []);

  useEffect(() => {
    console.log({ ModalType });
  }, []);

  useEffect(() => {
    console.log("floorsSelected", floorsSelected);
    if (ProjectPricingData?.floorRise?.length === 0) {
      setProjectPricingData((pre) => {
        pre?.floorRise.push({
          from: sortedUniq(floorsSelected)[0],
          to: null,
          value: null,
          type: "",
        });
        return { ...pre };
      });
    }
  }, [floorsSelected]);

  useEffect(() => {
    console.log(ProjectPricingData);
    // console.log('Edit-Data', data);
  }, [ProjectPricingData]);

  function getProjectDetails() {
    //*Wings-DropDown
    // getWingsByProjectId(projectId)
    //  ! vedashree changes
    getSelectedWingsByProjectId(projectId)
      .then((response) => {
        console.log("Wings-Dropdown-Data", response);
        let allWings = _.uniqBy(response.data, (wing) => (wing.wingId.wingId));
        allWings = allWings.map((wing) => (wing.wingId));
        console.log('allWings: ', allWings);
        setWingsData(allWings);
      })
      .catch((err) => {
        console.log("Wings-show-err", err);
      });


  }
  // ! vedashree changes
  //*unitType-Dropdown
  function getUniqInventoryTypes(wingId) {
    return new Promise((resolve, reject) => {
      getInventoryTypeFromProjectWing(projectId, BasePriceDetails.Wings && BasePriceDetails.Wings !== '' ? BasePriceDetails.Wings : wingId)
        .then((response22) => {
          console.log("Unit-type-Dropdown", response22);
          const data = response22.data.filter((f) => f.inventoryTypeId !== null);
          if (data) {
            setPriceListShow(true)
            // const UnitTypes = data.map((m) => m.inventoryTypeId).reduce((arr, ele) => {
            //   if (!arr.some((s) => s.inventoryTypeId === ele.inventoryTypeId)) {
            //     arr.push(ele);
            //   }
            //   return arr;
            // }, []).map((m, index) => ({
            //   label: m.type,
            //   value: m.inventoryTypeId,
            //   areaOptions: _.uniqBy(data, ).map((area) => area.saleableArea)
            // }))

            UnitTypes = uniqBy(data, (d) => d.inventoryTypeId.inventoryTypeId).map((opt) => ({
              label: opt.inventoryTypeId.type,
              value: opt.inventoryTypeId.inventoryTypeId,
              areaOptions: [],
            }));
            console.log("UnitTypes------->", UnitTypes);

            UnitTypes.forEach((unitType) => {
              data.forEach((d) => {
                if (d.inventoryTypeId.inventoryTypeId === unitType.value) {
                  if (!unitType.areaOptions.includes(d.saleableArea))
                    unitType.areaOptions.push(d.saleableArea);
                }
              });
            });
            // const areaOptions = _.groupBy(data, (d) => d.inventoryTypeId.type);
            // setAreaOptions(areaOptions);
            // console.log('areaOptions: ', areaOptions);
            console.log("------->", UnitTypes);
            console.log("priceData: ", priceData);
            const priceDataArr = [];
            if (ModalType === "add") {
              UnitTypes.forEach((ele) => {
                // uniqBy(priceData, "UnitTypeId").push({
                priceDataArr.push({
                  UnitType: ele.label,
                  UnitTypeId: ele.value,
                  areaOptions: ele.areaOptions.map((elm) => ({
                    BSP: "",
                    bspType: "",
                    BSPTotal: "",
                    sqft: elm,
                    REG: '',
                    flag: false,
                    OCR: "",
                    SDR: "",
                    Total: "",
                  })),

                })
              });
              setPriceData(priceDataArr);
            }

            // if (ModalType === 'Edit') {
            // UnitTypes.forEach(ele => {
            //   uniqBy(priceData, "UnitTypeId").push({
            //     UnitType: ele.label,
            //     UnitTypeId: ele.value,
            //     areaOptions: ele.areaOptions,
            //     UnitData: {
            //       BSP: '',
            //       sqft: '',
            //       bspType: '',
            //       BSPTotal: '',
            //       OCR: '',
            //       SDR: '',
            //       GST: '',
            //       Total: '',
            //     }
            //   })
            // })
            // ? getting duplicate values
            // } else if (ModalType === 'add') {
            //   UnitTypes.forEach(ele => {
            //     priceData?.push({
            //       UnitType: ele.label,
            //       UnitTypeId: ele.value,
            //       areaOptions: ele.areaOptions,
            //       UnitData: {
            //         BSP: '',
            //         sqft: '',
            //         bspType: '',
            //         BSPTotal: '',
            //         OCR: '',
            //         SDR: '',
            //         GST: '',
            //         Total: '',
            //       }
            //     })
            //   })
            // }

            setInventoryType(UnitTypes.label);
            // const SingleData = uniqBy(priceData, "UnitTypeId");
            const SingleData = uniqBy(priceDataArr, "UnitTypeId");

            setPriceData([...SingleData]);

            console.log("price-list-Data", SingleData);
            resolve(true);
          } else {
            setPriceListShow(false)
            reject();
          }
        })
        .catch((err) => {
          console.log("Inventory-Type-err", err);
          reject(err);
        });
    })
  }
  function CheckValue(value) {
    console.log(value);
    console.log("basePrice", BasePriceDetails?.Wings);
    if (BasePriceDetails?.Wings !== "") {
      console.log("already exists");
      CheckPricingDefault(projectId, BasePriceDetails?.Wings)
        .then((response) => {
          if (response.count === 0) {
            console.log("----->", response);
            setShowFields(false);
          } else {
            setShowFields(true);
          }
        })
        .catch((err) => {
          console.error("ShowFields", err);
        });
    } else {
      console.log("no , doesn't exists");
    }
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  function AccessToInventory() {
    //*check the wings and unitype by projectid
    const arr = [];
    //*Wing-table
    getSelectedWingsByProjectId(projectId)
      .then((wingItem) => {
        console.log("wingItem", wingItem);
        //*unit-type-table
        getInventoryTypeFromProjectName(projectId)
          .then((TypeItem) => {
            console.log("TypeItem", TypeItem);
            let uniqueValues = uniqBy(TypeItem.data, "inventoryTypeId.inventoryTypeId");
            console.log("uniqueValues", uniqueValues)
            let UniqueWings = _.uniqBy(wingItem.data, (wing) => (wing.wingId.wingId));
            UniqueWings = UniqueWings.map((wing) => (wing.wingId));
            console.log('UniqueWings: ', UniqueWings);
            UniqueWings.forEach((Item) => {
              arr.push({
                wingId: Item.wingId,

              });
              console.log("arr==", arr);


              //*Base-PriceTable
              getBasePricingByProjectId(projectId)
                .then((response) => {
                  console.log("response", response.data);
                  const UniqueData = uniqBy(response.data, "basePrices.inventoryTypeId")
                  console.log("UniqueData", UniqueData)
                  let pricingCheckCombination = response.data.map((m) => ({
                    wingID: m.wingId,
                  }));
                  console.log("pricingCheckCombination", pricingCheckCombination);
                  const FinalCheck = arr.map((m) =>
                    pricingCheckCombination.some((s) => s.wingID === m.wingId)
                  );
                  console.log("FinalCheck", FinalCheck);
                  let BooleanCheck = FinalCheck.every(Boolean);
                  console.log("!!!!!", BooleanCheck);
                  //*check-select-inventory n price-table n Booking Configuration
                  getProjectInventory(projectId).then((response78) => {
                    console.log("Data,data", response78)
                    getProjectByProjectName(projectId).then((response67) => {
                      console.log("Project-Data", response67)
                      if (BooleanCheck === true && response78.length > 0 && response67.data[0]?.bookingAmt > 0 && response67.data[0]?.bookingGst > 0 && response67.data[0]?.bookingOcr > 0 && response67.data[0]?.bookingSdr > 0) {
                        let obj = {
                          isCompleted: true,
                        };
                        updateFlagsToProjectTable(obj, projectId).then((resp) => {
                          console.log("sent-true", resp);
                        });
                      } else {
                        let FalseObj = {
                          isCompleted: false,
                        };
                        updateFlagsToProjectTable(FalseObj, projectId).then(
                          (resp) => {
                            console.log("sent-false", resp);
                          }
                        );
                      }
                    })

                  }).catch((err) => {
                    console.error("getProjectInventory", err)
                  })

                })
                .catch((err) => {
                  console.error("base-price-table", err);
                });
            });
          })
          .catch((err) => {
            console.error("TypeItem", err);
          });
      })
      .catch((err) => {
        console.error("wingItem", err);
      });
  }

  function ValidatePriceListData() {
    var form = true;
    if (BasePriceDetails.title === "") {
      form = false;
      setHelperText((pre) => {
        pre.title = "Please enter Title";
        return { ...pre };
      });
    }

    if (BasePriceDetails.Wings === "") {
      form = false;
      setHelperText((pre) => {
        pre.Wings = "Please select Wing";
        return { ...pre };
      });
    }

    // if(BasePriceDetails.floorRise === '') {
    //   form = false;
    //   setHelperText((pre) => {
    //     pre.floorRise = "Please select floorRise";
    //     return {...pre};
    //   })
    // }

    // if(BasePriceDetails.parking === '') {
    //   form = false;
    //   setHelperText((pre) => {
    //     pre.parking = "PLease select parking";
    //     return {...pre};
    //   })
    // }

    // if(BasePriceDetails.plc === '') {
    //   form = false;
    //   setHelperText((pre) => {
    //     pre.plc = "PLease select plc";
    //     return {...pre};
    //   })
    // }

    return {
      flag: form,
    };
  }


  function OnSubmit() {
    console.log("---->", ProjectPricingData);
    // let flag = ValidatePriceListData();
    // ! vedashree changes => loader added
    presentLoader();
    if (ModalType === "Edit") {
      console.log("data", data);

      // let eachData = priceData.map((m) => ({
      //   projectId: projectId,
      //   wingId: BasePriceDetails?.Wings,
      //   REG: (m?.UnitData?.BSP * 0.07).toFixed(2),
      //   floorRise: ProjectPricingData?.floorRise,
      //   parking: ProjectPricingData?.parking,
      //   plc: ProjectPricingData?.plc,
      //   title: BasePriceDetails?.title,
      //   startDateTime: BasePriceDetails.StartDate
      //     ? new Date(BasePriceDetails.StartDate).getTime()
      //     : null,
      //   endDateTime: BasePriceDetails.EndDate
      //     ? new Date(BasePriceDetails.EndDate).getTime()
      //     : null,
      //   inventoryTypeId: m.UnitTypeId,
      //   GST: m?.UnitData?.GST,
      //   BSP: m?.UnitData?.BSP,
      //   Total: "0",
      //   sqft: m?.UnitData?.sqft,
      //   SDR: m?.UnitData?.SDR,
      //   OCR: "0",
      // }));
      // let eachData = [];
      // priceData.forEach((m, index) => {
      //   m.UnitData.forEach((eachUnitData) => {
      //     let object = {
      //       projectId: projectId,
      //       wingId: BasePriceDetails?.Wings,
      //       REG: (eachUnitData?.BSP * 0.07).toFixed(2),
      //       floorRise: ProjectPricingData?.floorRise,
      //       parking: ProjectPricingData?.parking,
      //       plc: ProjectPricingData?.plc,
      //       title: BasePriceDetails?.title,
      //       startDateTime: BasePriceDetails.StartDate
      //         ? new Date(BasePriceDetails.StartDate).getTime()
      //         : null,
      //       endDateTime: BasePriceDetails.EndDate
      //         ? new Date(BasePriceDetails.EndDate).getTime()
      //         : null,
      //       inventoryTypeId: m.UnitTypeId,
      //       GST: parseFloat(eachUnitData?.GST),
      //       BSP: parseFloat(eachUnitData?.BSP),
      //       Total:
      //         eachUnitData?.Total === ""
      //           ? 0
      //           : parseFloat(eachUnitData?.Total),
      //       sqft: eachUnitData?.sqft,
      //       SDR: parseFloat(eachUnitData?.SDR),
      //       OCR:
      //         eachUnitData?.OCR === ""
      //           ? 0
      //           : parseFloat(eachUnitData?.OCR),
      //       bspType: eachUnitData?.bspType,
      //       BSPTotal: parseFloat(eachUnitData?.BSPTotal),
      //     };
      //     eachData.push(object);
      //   });
      // });
      // console.log("element --->", eachData);
      // ! vedashree changes start
      let eachData = [];
      let allBasePrices = [];
      priceData.forEach((m, index) => {
        m.areaOptions = m.areaOptions.map((opt) => {
          opt.inventoryTypeId = m.UnitTypeId;
          opt.GST = parseFloat(opt.GST);
          opt.REG = parseFloat(opt.REG);
          opt.SDR = parseFloat(opt.SDR);
          // ? areaOptions from priceData to form a single array
          allBasePrices.push(opt);
          return opt;
        });
      });
      console.log('priceData: ', priceData);

      //  ! ---------end
      console.log('allBasePrices: ', allBasePrices);
      const obj = {
        projectId: projectId,
        wingId: BasePriceDetails?.Wings,
        floorRise: ProjectPricingData?.floorRise,
        parking: ProjectPricingData?.parking,
        // plc: ProjectPricingData?.plc,
        title: BasePriceDetails?.title,
        startDateTime: BasePriceDetails.StartDate ? new Date(BasePriceDetails.StartDate).getTime() : null,
        endDateTime: BasePriceDetails.EndDate ? new Date(BasePriceDetails.EndDate).getTime() : null,
        inventoryTypeId: null,
        REG: null,
        basePrices: allBasePrices,        // ! vedashree changes
        BSP: null,
        Total: null,
        sqft: null,
        SDR: null,
        OCR: null,
        bspType: null,
        BSPTotal: null,
      };
      eachData.push(obj);
      console.log("eachData --->", eachData);
      for (let index = 0; index < eachData.length; index++) {
        const element = eachData[index];
        UpdateProjectPricing(element, data?.projectPricingId)
          .then((res) => {
            console.log("successFully added", res);
            if (index === eachData.length - 1) {
              handleClose();
              successTost("Base Price added successfully!");
              BasePriceResp(true);
              AccessToInventory();
            }
            dismissLoader();
          })
          .catch((err) => {
            console.log("Add-Base-Price", err);
            dismissLoader();
          });
      }
    } else if (ModalType === "add") {
      console.log("Add new");

      console.log(
        " ProjectPricingData?.floorRise[0].to",
        ProjectPricingData?.floorRise[0].to
      );
      console.log("floorsSelected?.length", floorsSelected?.length);
      // ! why check floorsSelected? it is not mandatory;
      // if (Math.max(...ProjectPricingData?.floorRise.map(m => m.to)) === floorsSelected?.length) {
      // ! as per changes told in 1st week of march, 2023; multiple lists can be added for same wing, same date & time
      // CheckProjectPricingDetails(
      //   projectId,
      //   BasePriceDetails?.Wings,
      //   new Date(BasePriceDetails.StartDate).getTime(),
      //   new Date(BasePriceDetails.EndDate).getTime()
      // ).then((response0) => {
      //   console.log("-Data-", response0);
      //   if (response0.data.length === 0) {
      console.log("Price-List-Data", priceData);

      // let eachData = priceData.map(m => ({
      //   projectId: projectId,
      //   wingId: BasePriceDetails?.Wings,
      //   REG: (m?.UnitData?.BSP * 0.07).toFixed(2),
      //   floorRise: ProjectPricingData?.floorRise,
      //   parking: ProjectPricingData?.parking,
      //   plc: ProjectPricingData?.plc,
      //   title: BasePriceDetails?.title,
      //   startDateTime: BasePriceDetails.StartDate ? new Date(BasePriceDetails.StartDate).getTime() : null,
      //   endDateTime: BasePriceDetails.EndDate ? new Date(BasePriceDetails.EndDate).getTime() : null,
      //   inventoryTypeId: m.UnitTypeId,
      //   GST: parseFloat(m?.UnitData?.GST),
      //   BSP: parseFloat(m?.UnitData?.BSP),
      //   Total: m?.UnitData?.Total === '' ? 0 : parseFloat(m?.UnitData?.Total),
      //   sqft: m?.UnitData?.sqft,
      //   SDR: parseFloat(m?.UnitData?.SDR),
      //   OCR: m?.UnitData?.OCR === '' ? 0 : parseFloat(m?.UnitData?.OCR),
      //   bspType: m?.UnitData?.bspType,
      //   BSPTotal: parseFloat(m?.UnitData?.BSPTotal),
      // }))
      // let eachData = priceData.map((m, index) => ({
      //   projectId: projectId,
      //   wingId: BasePriceDetails?.Wings,
      //   floorRise: ProjectPricingData?.floorRise,
      //   parking: ProjectPricingData?.parking,
      //   plc: ProjectPricingData?.plc,
      //   title: BasePriceDetails?.title,
      //   startDateTime: BasePriceDetails.StartDate
      //     ? new Date(BasePriceDetails.StartDate).getTime()
      //     : null,
      //   endDateTime: BasePriceDetails.EndDate
      //     ? new Date(BasePriceDetails.EndDate).getTime()
      //     : null,
      //   inventoryTypeId: m.UnitTypeId,
      //   REG: null,
      //   basePrices: m.areaOptions,
      //   BSP: null,
      //   Total: null,
      //   sqft: null,
      //   SDR: null,
      //   OCR: null,
      //   bspType: null,
      //   BSPTotal: null,
      // }));
      // ! vedashree changes start
      let eachData = [];
      let allBasePrices = [];
      priceData.forEach((m, index) => {
        m.areaOptions = m.areaOptions.map((opt) => {
          opt.inventoryTypeId = m.UnitTypeId;
          opt.GST = parseFloat(opt.GST);
          opt.REG = parseFloat(opt.REG);
          opt.SDR = parseFloat(opt.SDR);
          // ? areaOptions from priceData to form a single array
          allBasePrices.push(opt);
          return opt;
        });
      });
      console.log('priceData: ', priceData);

      //  ! ---------end
      console.log('allBasePrices: ', allBasePrices);
      const obj = {
        projectId: projectId,
        wingId: BasePriceDetails?.Wings,
        floorRise: ProjectPricingData?.floorRise,
        parking: ProjectPricingData?.parking,
        // plc: ProjectPricingData?.plc,
        title: BasePriceDetails?.title,
        startDateTime: BasePriceDetails.StartDate ? new Date(BasePriceDetails.StartDate).getTime() : null,
        endDateTime: BasePriceDetails.EndDate ? new Date(BasePriceDetails.EndDate).getTime() : null,
        inventoryTypeId: null,
        REG: null,
        basePrices: allBasePrices,        // ! vedashree changes
        BSP: null,
        Total: null,
        sqft: null,
        SDR: null,
        OCR: null,
        bspType: null,
        BSPTotal: null,
      };
      eachData.push(obj);
      console.log("eachData --->", eachData);

      for (let index = 0; index < eachData.length; index++) {
        const element = eachData[index];
        AddProjectPricing(element)
          .then((res) => {
            console.log("successFully added", res);
            if (index === eachData.length - 1) {
              handleClose();
              successTost("Base Price updated successfully!");
              BasePriceResp(true);
              AccessToInventory();
            }
            dismissLoader();
          })
          .catch((err) => {
            console.log("Add-Base-Price", err);
            dismissLoader();
          });
      }
      //   } else {
      //     infoTost("Already exists!");
      //   }
      // });

      // } else {
      //   infoTost('please select all the floors!')
      // }
    }
  }

  function getBasePriceDetails() {
    if (ModalType === "Edit") {
      getProjectDataByProjectId(projectId).then(async (resp) => {
        console.log("Inventory-data", resp);
        let Units = groupBy(resp.data, "floorNo");
        console.log("Units", Units);
        Object.keys(Units).forEach((floor) => {
          console.log("floor", floor);
          setFloorsSelected((pre) => {
            pre.push(floor);
            return [...pre];
          });
        });

        setProjectPricingData(data);
        console.log('modal', { data })
        setBasePriceDetails({
          projectId: data.projectId,
          Wings: data.wingId.wingId,
          floorRise: data?.floorRise,
          parking: data.parking,
          // plc: data.plc,
          title: data.title,
        });

        console.log("BasePriceDetails", data);
        console.log("price-Data-check", priceData);
        // setPriceData((pre)=>{
        //   pre.UnitType=data?.inventoryTypeId.type;
        //   pre.UnitTypeId=data?.inventoryTypeId.inventoryTypeId;
        //   pre.areaOptions=sqaureOptions;
        //   pre.UnitData=obj;
        //       return [...pre];

        // })
        // priceData?.push({
        //   UnitType: data?.inventoryTypeId.type,
        //   UnitTypeId: data?.inventoryTypeId.inventoryTypeId,
        //   areaOptions: data?.basePrices,
        // })
        // ! vedashree changes
        getUniqInventoryTypes(data.wingId.wingId).then(() => {
          // ? group areaOptions by inventoryTypeId
          const pricesArr = _.uniqBy(data.basePrices, ((d) => d.inventoryTypeId)).map((opt) => {
            console.log('opt: ', opt);
            return {
              UnitType: _.find(UnitTypes, (type) => { return type.value === opt.inventoryTypeId }).label,
              UnitTypeId: opt.inventoryTypeId,
              areaOptions: [],
            }
          });
          pricesArr.forEach((unitType) => {
            data.basePrices.forEach((d) => {
              if (d.inventoryTypeId === unitType.UnitTypeId) {
                // if (!unitType.areaOptions.includes(d.saleableArea))
                unitType.areaOptions.push(d);
              }
            });
          });
          setPriceData(pricesArr);
        })
      });
      // console.log("after-------------", { priceData });
      // setPriceData([...priceData]);
    } else if (ModalType === "add") {
      console.log("add new");
      setProjectPricingData({
        projectId: projectId,
        wingId: BasePriceDetails?.Wings,
        floorRise: [],
        parking: [],
        // plc: [],
        title: BasePriceDetails?.title,
        startDateTime: BasePriceDetails.StartDate
          ? new Date(BasePriceDetails.StartDate).getTime()
          : null,
        endDateTime: BasePriceDetails.EndDate
          ? new Date(BasePriceDetails.EndDate).getTime()
          : null,
      });

      getProjectDataByProjectId(projectId)
        .then((resp) => {
          console.log("Inventory-data", resp);
          let Units = groupBy(resp.data, "floorNo");
          console.log("Units", Units);
          Object.keys(Units).forEach((floor) => {
            console.log("floor", floor);
            setFloorsSelected((pre) => {
              pre.push(floor);
              return [...pre];
            });
          });

          setInventoryData(resp.data);
          // let views = groupBy(resp.data, "view");
          // console.log(views);
          // Object.keys(views).forEach((e) => {
          //   console.log(e);
          //   setProjectPricingData((pre) => {
          //     console.log(pre);
          //     if (pre.plc) {
          //       pre.plc.push({
          //         name: e,
          //         value: null,
          //         type: "",
          //       });
          //       return { ...pre };
          //     } else {
          //       pre.plc = [
          //         {
          //           name: e,
          //           value: null,
          //           type: "",
          //         },
          //       ];
          //     }
          //     return { ...pre };
          //   });
          // });
        })
        .catch((err) => {
          console.log("Project-Data-err", err);
        });
    }
  }

  function handleEmptyClose() {
    handleClose();
    if (ModalType === "add") {
      setBasePriceDetails((pre) => {
        pre.title = "";
        pre.RegPercentage = "";
        pre.StartDate = "";
        pre.EndDate = "";
        pre.Wings = "";
        pre.floorRise = [];
        pre.parking = [];
        // pre.plc = [];
        return { ...pre };
      });

      setHelperText((pre) => {
        pre.title = "";
        pre.RegPercentage = "";
        pre.StartDate = "";
        pre.EndDate = "";
        pre.Wings = "";
        pre.floorRise = [];
        pre.parking = [];
        // pre.plc = [];
        return { ...pre };
      });

      setPriceData({
        BSP: "",
        sqft: "",
        bspType: "",
        BSPTotal: "",
        OCR: "",
        SDR: "",
        GST: "",
        Total: "",
      });
    }
  }


  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
    >
      <Box sx={style}>
        <Box className={cssClasses.headerDiv}>
          <Box className={cssClasses.flexRow}>
            <Box className={cssClasses.flexCol}>
              <Box className={cssClasses.HeaderTitle} mt={1}>
                {ModalType === "Edit" ? "Edit Base Price" : "Add Base Price"}
              </Box>
            </Box>
            <Box
              ml={"auto"}
              mt={1}
              onClick={handleEmptyClose}
              style={{ cursor: "pointer" }}
            >
              <Close width={"1.2rem"} height={"1.2rem"} />
            </Box>
          </Box>
        </Box>

        <Box width={"100%"} height={"80%"} overflow={"auto"}>
          <Box margin={"2rem"}>
            <Box className={cssClasses.flexRow1} mt={2}>
              <Box className={cssClasses.flexRow1} mb={2}>
                <Box className={cssClasses.InputTitle} mt={1.5}>
                  Title
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <CustomInput
                    inputType={"text"}
                    placeholder={"Enter Title"}
                    value={BasePriceDetails.title}
                    handleChange={(_value) => {
                      setBasePriceDetails((pre) => {
                        pre.title = _value;
                        return { ...pre };
                      });

                      setHelperText((pre) => {
                        pre.title = "";
                        return { ...pre };
                      });
                    }}
                  />
                </Box>
              </Box>

              <Box className={cssClasses.flexRow1} mb={2}>
                <Box className={cssClasses.InputTitle} mt={1.5}>
                  REG %<span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <DropDown
                    placeHolder={"Select"}
                    list={["7%"]}
                    selectedValue={["7%"]}
                    onChangeSelect={(value) => {
                      setBasePriceDetails((pre) => {
                        pre.RegPercentage = value;
                        console.log("regPercentage", value);
                        return { ...pre };
                      });
                    }}
                    style={{
                      background: "#F2F4F7",
                      selectedColor: "#667085",
                    }}
                  />
                </Box>
              </Box>
            </Box>

            <>
              <Box className={cssClasses.flexRow1}>
                <Box className={cssClasses.flexRow1} mb={2}>
                  <Box className={cssClasses.InputTitle} mt={1.5}>
                    Wing
                    <span className={cssClasses.Star}>*</span>
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <DropDown
                      placeHolder={"Select"}
                      list={WingsData.map((ele, id) => {
                        return {
                          label: ele.wingName,
                          value: ele.wingId,
                        };
                      })}
                      selectedValue={BasePriceDetails.Wings}
                      disable={BasePriceDetails.title === ""}
                      onChangeSelect={(value) => {
                        setBasePriceDetails((pre) => {
                          pre.Wings = value;
                          CheckValue(value);
                          getUniqInventoryTypes();
                          return { ...pre };
                        });

                        setHelperText((pre) => {
                          pre.Wings = "";
                          return { ...pre };
                        });
                      }}
                      style={{
                        background: "#F2F4F7",
                        selectedColor: "#667085",
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              {ShowFields === true && (
                <>
                  <Box className={cssClasses.flexRow1}>
                    <Box className={cssClasses.flexRow1} mb={2}>
                      <Box className={cssClasses.InputTitle} mt={1.5}>
                        Start Date
                        <span className={cssClasses.Star}>*</span>
                      </Box>
                      <Box className={cssClasses.widthBox}>
                        <DateComponent
                          value={BasePriceDetails.StartDate}
                          // disabled={BasePriceDetails.title === ''}
                          onChangeDate={(_value) => {
                            console.log("Start-Date", _value);
                            setBasePriceDetails((pre) => {
                              pre.StartDate = _value;
                              return { ...pre };
                            });
                            setHelperText((pre) => {
                              pre.StartDate = "";
                              return { ...pre };
                            });
                          }}
                          helperText={HelperText.StartDate}
                        />
                      </Box>
                    </Box>

                    <Box className={cssClasses.flexRow1} mb={2}>
                      <Box className={cssClasses.InputTitle} mt={1.5}>
                        End Date
                        <span className={cssClasses.Star}>*</span>
                      </Box>
                      <Box className={cssClasses.widthBox}>
                        <DateComponent
                          value={BasePriceDetails.EndDate}
                          // disabled={BasePriceDetails.StartDate === ''}
                          onChangeDate={(_value) => {
                            console.log("End-Date", _value);
                            setBasePriceDetails((pre) => {
                              pre.EndDate = _value;
                              return { ...pre };
                            });
                            setHelperText((pre) => {
                              pre.EndDate = "";
                              return { ...pre };
                            });
                            if (BasePriceDetails.StartDate > _value) {
                              setHelperText((pre) => {
                                pre.EndDate =
                                  "Select end date greater than start date";
                                return { ...pre };
                              });
                            }
                          }}
                          helperText={HelperText.EndDate}
                        />
                      </Box>
                    </Box>
                  </Box>
                </>
              )}

              {priceListShow === true && (
                <>
                  <Divider />

                  {priceData?.map((m, index) => (
                    <Box className={cssClasses.FirstDiv} mt={1}>
                      {/* <Box sm={{width: '15%'}}> */}
                      <Box className={cssClasses.label} width="15%">
                      Agreement Value for <span className={cssClasses.Star}>*</span>
                      </Box>
                      {/* </Box> */}
                      {/* <Box sm={{width: '85%'}}> */}
                      <Box className={cssClasses.RightDiv}>
                        <Box
                          mb={2}
                          display={"flex"}
                          flexDirection={"row"}
                          justifyContent={"space-between"}
                        >
                          <Box width={"Fit-Content"}>
                            <CustomInput
                              style={{
                                background: "#FFFFFF !important",
                                pointerEvents: "none",

                              }}
                              value={m?.UnitType}
                            />
                          </Box>
                        </Box>
                        {m?.areaOptions?.map((eachUnit, unitDataIndex) => (
                          <>
                            <Box className={cssClasses.SecondDiv} mb={1} mt={2}>
                              <Box className={cssClasses.inputWrap}>
                                <Box
                                  className={cssClasses.InputTitle}
                                  width={"fit-Content"}>Area(Sq Ft)</Box>
                                <Box width={"100%"}>
                                  <CustomInput
                                    style={{ pointerEvents: "none", }}
                                    inputType={'number'}
                                    value={eachUnit.sqft}
                                    disabled={true}
                                  />
                                </Box>
                              </Box>

                              <Box className={cssClasses.inputWrap}>
                                <Box className={cssClasses.InputTitle}>Agreement Value</Box>
                                <Box width={"100%"}>
                                  <CustomInput
                                    inputType={"number"}
                                    value={eachUnit?.BSP}
                                    // disabled={BasePriceDetails.Wings === ''}
                                    disabled={priceData[index].areaOptions[unitDataIndex].flag === true}
                                    handleChange={(_value) => {
                                      console.log({ priceData });
                                      if (priceData[index].areaOptions[unitDataIndex].flag === false) {
                                        console.log({ priceData });
                                        setPriceData((pre) => {
                                          pre[index].areaOptions[unitDataIndex].BSP = parseInt(_value);
                                          return [...pre];
                                        });
                                        if (_value !== "" && priceData[index].areaOptions[unitDataIndex].bspType === "Value") {
                                          // const BspData = parseInt(priceData[index]?.UnitData?.BSP) / (1 + 7 / 100 + 1 / 100)

                                          priceData[index].areaOptions[unitDataIndex].BSP = parseFloat(_value); //*BSP
                                          priceData[index].areaOptions[unitDataIndex].BSPTotal = parseFloat(_value).toFixed(2); //*BSP-Total
                                          // * GST will be based on Agreement Value
                                          if (priceData[index].BSPTotal >= 4500000) {
                                            priceData[index].areaOptions[unitDataIndex].GST = parseInt(_value) * 0.05; //*GST
                                          } else {
                                            priceData[index].areaOptions[unitDataIndex].GST = parseInt(_value) * 0.01; //*GST
                                          }
                                          // * SDR = 7% of Agreement Value
                                          priceData[index].areaOptions[unitDataIndex].REG = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07; //*REG
                                          priceData[index].areaOptions[unitDataIndex].SDR = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.07).toFixed(2); //*SDR
                                          //  priceData[index].UnitData.OCR = 100000;
                                          //  priceData[index].UnitData.SDR = 500000 - 100000 - parseInt(priceData[index]?.UnitData?.GST);
                                          //  const AllTotal = parseInt(priceData[index]?.UnitData?.OCR) + parseInt(priceData[index]?.UnitData?.SDR) + parseInt(priceData[index]?.UnitData?.GST)
                                          const AllTotal = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) + parseInt(priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST); //*Total

                                          priceData[index].areaOptions[unitDataIndex].Total = AllTotal;

                                          console.log("priceData", priceData);
                                          setPriceData([...priceData]);

                                        } else if (_value !== "" && priceData[index].areaOptions[unitDataIndex].sqft !== "" && priceData[index].areaOptions[unitDataIndex].bspType === "per sq ft") {
                                          if (_value !== "" && priceData[index].areaOptions[unitDataIndex].bspType === "Value") {
                                            // const BspData = parseInt(priceData[index]?.UnitData?.BSP) / (1 + 7 / 100 + 1 / 100)

                                            priceData[index].areaOptions[unitDataIndex].BSPTotal = parseInt(_value) * parseInt(priceData[index].areaOptions[unitDataIndex].sqft).toFixed(2); //*BSP-Total

                                            if (priceData[index].areaOptions[unitDataIndex].BSPTotal >= 4500000) {
                                              priceData[index].areaOptions[unitDataIndex].GST = (
                                                priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.05).toFixed(2); //*GST
                                            } else {
                                              priceData[index].areaOptions[unitDataIndex].GST = (
                                                priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.01).toFixed(2); //*GST
                                            }
                                            priceData[index].areaOptions[unitDataIndex].REG = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07; //*REG
                                            priceData[index].areaOptions[unitDataIndex].SDR = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.07).toFixed(2); //*SDR
                                            // priceData[index].UnitData[unitDataIndex].OCR = 100000;
                                            // priceData[index].UnitData[unitDataIndex].SDR = 500000 - 100000 - priceData[index]?.UnitData[unitDataIndex]?.GST;
                                            // priceData[index].UnitData[unitDataIndex].Total = parseInt(priceData[index]?.UnitData[unitDataIndex]?.OCR) + parseInt(priceData[index]?.UnitData[unitDataIndex]?.SDR) + parseInt(priceData[index]?.UnitData[unitDataIndex]?.GST);

                                            priceData[index].areaOptions[unitDataIndex].Total = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) + parseInt(
                                              priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST); //*Total


                                            console.log("priceData", priceData);
                                            setPriceData([...priceData]);
                                          }
                                          priceData[index].areaOptions[unitDataIndex].BSP = parseFloat(_value); //*BSP
                                          priceData[index].areaOptions[unitDataIndex].BSPTotal = parseFloat(_value).toFixed(2); //*BSP-Total
                                          // * GST will be based on Agreement Value
                                          if (priceData[index].BSPTotal >= 4500000) {
                                            priceData[index].areaOptions[unitDataIndex].GST = parseInt(_value) * 0.05; //*GST
                                          } else {
                                            priceData[index].areaOptions[unitDataIndex].GST = parseInt(_value) * 0.01; //*GST
                                          }
                                          // * SDR = 7% of Agreement Value
                                          priceData[index].areaOptions[unitDataIndex].REG = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07; //*REG
                                          priceData[index].areaOptions[unitDataIndex].SDR = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.07).toFixed(2); //*SDR
                                          //  priceData[index].UnitData.OCR = 100000;
                                          //  priceData[index].UnitData.SDR = 500000 - 100000 - parseInt(priceData[index]?.UnitData?.GST);
                                          //  const AllTotal = parseInt(priceData[index]?.UnitData?.OCR) + parseInt(priceData[index]?.UnitData?.SDR) + parseInt(priceData[index]?.UnitData?.GST)
                                          const AllTotal = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) + parseInt(priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST); //*Total

                                          priceData[index].areaOptions[unitDataIndex].Total = AllTotal;

                                          console.log("priceData", priceData);
                                          setPriceData([...priceData]);

                                        } else if (_value !== "" && priceData[index].areaOptions[unitDataIndex].sqft !== "" && priceData[index].areaOptions[unitDataIndex].bspType === "per sq ft") {

                                          priceData[index].areaOptions[unitDataIndex].BSPTotal = parseInt(_value) * parseInt(priceData[index].areaOptions[unitDataIndex].sqft).toFixed(2); //*BSP-Total

                                          if (priceData[index].areaOptions[unitDataIndex].BSPTotal >= 4500000) {
                                            priceData[index].areaOptions[unitDataIndex].GST = (
                                              priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.05).toFixed(2); //*GST
                                          } else {
                                            priceData[index].areaOptions[unitDataIndex].GST = (
                                              priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.01).toFixed(2); //*GST
                                          }
                                          priceData[index].areaOptions[unitDataIndex].REG = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07; //*REG
                                          priceData[index].areaOptions[unitDataIndex].SDR = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.07).toFixed(2); //*SDR
                                          // priceData[index].UnitData[unitDataIndex].OCR = 100000;
                                          // priceData[index].UnitData[unitDataIndex].SDR = 500000 - 100000 - priceData[index]?.UnitData[unitDataIndex]?.GST;
                                          // priceData[index].UnitData[unitDataIndex].Total = parseInt(priceData[index]?.UnitData[unitDataIndex]?.OCR) + parseInt(priceData[index]?.UnitData[unitDataIndex]?.SDR) + parseInt(priceData[index]?.UnitData[unitDataIndex]?.GST);

                                          priceData[index].areaOptions[unitDataIndex].Total = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) + parseInt(
                                            priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST); //*Total


                                          console.log("priceData", priceData);
                                          setPriceData([...priceData]);
                                        }
                                      } else if (priceData[index].areaOptions[unitDataIndex].flag === true) {
                                      }
                                    }}
                                    placeholder={"Enter BSP"}
                                  />
                                </Box>
                              </Box>
                              <Box className={cssClasses.inputWrap} mr={0.8}>
                                <Box className={cssClasses.InputTitle}>Type</Box>
                                <Box width={"100%"} mt={0.8} >
                                  <DropDown
                                    placeHolder={"Select"}
                                    selectedValue={eachUnit?.bspType}
                                    // disable={BasePriceDetails.title === '' || BasePriceDetails.Wings === ''}
                                    onChangeSelect={(_value) => {
                                      setPriceData((pre) => {
                                        pre[index].areaOptions[unitDataIndex].bspType =
                                          _value;
                                        return [...pre];
                                      });
                                      if (priceData[index].areaOptions[unitDataIndex].flag === false) {
                                        if (priceData[index].areaOptions[unitDataIndex].BSP !== "" && priceData[index].areaOptions[unitDataIndex].bspType === "Value") {
                                          if (priceData[index].areaOptions[unitDataIndex].BSP >= 4500000) {
                                            priceData[index].areaOptions[unitDataIndex].GST =
                                              parseInt(priceData[index].areaOptions[unitDataIndex].BSP) * 0.05; //*GST
                                          } else {
                                            priceData[index].areaOptions[unitDataIndex].GST =
                                              parseInt(priceData[index].areaOptions[unitDataIndex].BSP) * 0.01; //*GST
                                          }
                                          // const BspData = parseInt(priceData[index].areaOptions[unitDataIndex]?.BSP) / (1 + 7 / 100 + 1 / 100)
                                          priceData[index].areaOptions[unitDataIndex].BSP = parseInt(priceData[index].areaOptions[unitDataIndex].BSP); //*BSP
                                          priceData[index].areaOptions[unitDataIndex].REG = (parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07).toFixed(2); //*REG
                                          // console.log("BSP" , priceData[index].areaOptions[unitDataIndex].BSP)
                                          priceData[index].areaOptions[unitDataIndex].BSPTotal = parseFloat(
                                            priceData[index].areaOptions[unitDataIndex].BSP).toFixed(2); //*BSP-Total
                                          priceData[index].areaOptions[unitDataIndex].SDR = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.07).toFixed(2); //*SDR

                                          // priceData[index].OCR = 100000;
                                          // priceData[index].SDR = 500000 - 100000 - parseInt(priceData[index]??.GST);
                                          // const AllTotal = parseInt(priceData[index]??.OCR) + parseInt(priceData[index]??.SDR) + parseInt(priceData[index]??.GST)
                                          const AllTotal = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) + parseInt(priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST);
                                          priceData[index].areaOptions[unitDataIndex].Total = AllTotal; //*Total

                                          console.log("priceData22", priceData);
                                          setPriceData([...priceData]);


                                        } else if (priceData[index].areaOptions[unitDataIndex].BSP && priceData[index].areaOptions[unitDataIndex].bspType === "per sq ft") {
                                          priceData[index].areaOptions[unitDataIndex].BSPTotal = parseFloat(priceData[index].areaOptions[unitDataIndex].BSP) *
                                            parseFloat(priceData[index].areaOptions[unitDataIndex].sqft).toFixed(2); //*BSP-Total
                                          if (priceData[index].areaOptions[unitDataIndex].BSPTotal >= 4500000) {
                                            priceData[index].areaOptions[unitDataIndex].GST = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.05).toFixed(2); //*GST
                                          } else {
                                            priceData[index].areaOptions[unitDataIndex].GST = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.01).toFixed(2); //*GST
                                          }

                                          if (priceData[index].areaOptions[unitDataIndex].flag === false) {
                                            setPriceData((pre) => {
                                              pre[index].areaOptions[unitDataIndex].bspType =
                                                _value;
                                              return [...pre];
                                            });
                                            if (priceData[index].areaOptions[unitDataIndex].BSP !== "" && priceData[index].areaOptions[unitDataIndex].bspType === "Value") {
                                              if (priceData[index].areaOptions[unitDataIndex].BSP >= 4500000) {
                                                priceData[index].areaOptions[unitDataIndex].GST =
                                                  parseInt(priceData[index].areaOptions[unitDataIndex].BSP) * 0.05; //*GST
                                              } else {
                                                priceData[index].areaOptions[unitDataIndex].GST =
                                                  parseInt(priceData[index].areaOptions[unitDataIndex].BSP) * 0.01; //*GST
                                              }
                                              // const BspData = parseInt(priceData[index].areaOptions[unitDataIndex]?.BSP) / (1 + 7 / 100 + 1 / 100)
                                              priceData[index].areaOptions[unitDataIndex].BSP = parseInt(priceData[index].areaOptions[unitDataIndex].BSP); //*BSP
                                              priceData[index].areaOptions[unitDataIndex].REG = (parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07).toFixed(2); //*REG
                                              // console.log("BSP" , priceData[index].areaOptions[unitDataIndex].BSP)
                                              priceData[index].areaOptions[unitDataIndex].BSPTotal = parseFloat(
                                                priceData[index].areaOptions[unitDataIndex].BSP).toFixed(2); //*BSP-Total
                                              priceData[index].areaOptions[unitDataIndex].SDR = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.07).toFixed(2); //*SDR
                                              // priceData[index].OCR = 100000;
                                              // priceData[index].SDR = 500000 - 100000 - parseInt(priceData[index]??.GST);
                                              // const AllTotal = parseInt(priceData[index]??.OCR) + parseInt(priceData[index]??.SDR) + parseInt(priceData[index]??.GST)
                                              const AllTotal = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) + parseInt(priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST);
                                              priceData[index].areaOptions[unitDataIndex].Total = AllTotal; //*Total
                                              console.log("priceData22", priceData);
                                              setPriceData([...priceData]);
                                            } else if (priceData[index].areaOptions[unitDataIndex].BSP && priceData[index].areaOptions[unitDataIndex].bspType === "per sq ft") {
                                              priceData[index].areaOptions[unitDataIndex].BSPTotal = parseFloat(priceData[index].areaOptions[unitDataIndex].BSP) *
                                                parseFloat(priceData[index].areaOptions[unitDataIndex].sqft).toFixed(2); //*BSP-Total
                                              if (priceData[index].areaOptions[unitDataIndex].BSPTotal >= 4500000) {
                                                priceData[index].areaOptions[unitDataIndex].GST = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.05).toFixed(2); //*GST
                                              } else {
                                                priceData[index].areaOptions[unitDataIndex].GST = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.01).toFixed(2); //*GST
                                              }
                                              priceData[index].areaOptions[unitDataIndex].REG = (parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07).toFixed(2); //*REG
                                              priceData[index].areaOptions[unitDataIndex].SDR = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.07).toFixed(2); //*SDR
                                              // priceData[index].areaOptions[unitDataIndex].REG = (parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07).toFixed(2); //*REG
                                              // priceData[index].areaOptions[unitDataIndex].SDR = (priceData[index].areaOptions[unitDataIndex].BSPTotal * 0.07).toFixed(2); //*SDR
                                              // priceData[index].OCR = 100000;
                                              // priceData[index].SDR = 500000 - 100000 - priceData[index]?.GST;
                                              // priceData[index].Total = parseInt(priceData[index]?.OCR) + parseInt(priceData[index]?.SDR) + parseInt(priceData[index]?.GST);
                                              priceData[index].areaOptions[unitDataIndex].Total = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) +
                                                parseInt(priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST); //*ToTal

                                              // priceData[index].OCR = 100000;
                                              // priceData[index].SDR = 500000 - 100000 - priceData[index]?.GST;
                                              // priceData[index].Total = parseInt(priceData[index]?.OCR) + parseInt(priceData[index]?.SDR) + parseInt(priceData[index]?.GST);
                                              priceData[index].areaOptions[unitDataIndex].Total = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) +
                                                parseInt(priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST); //*ToTal

                                              console.log("priceData", priceData);
                                              setPriceData([...priceData]);
                                            }
                                            console.log("priceData", priceData);
                                            setPriceData([...priceData]);
                                          }
                                        }
                                      }

                                      // console.log("m?.areaOptions.length - 1" ,priceData[index].areaOptions[unitDataIndex.length - 1].Total)
                                      if (priceData[index].areaOptions[priceData[index].areaOptions.length - 1].Total !== '') {
                                        // console.log("m?.areaOptions.length - 1", priceData[0].areaOptions[unitDataIndex.length - 1].Total)
                                        setSaveData(false);
                                      }

                                    }}
                                    list={["Value", "per sq ft"]}
                                  />
                                </Box>
                              </Box>
                              <Box className={cssClasses.inputWrap}>
                                <Box className={cssClasses.InputTitle}>
                                  Agreement Value
                                </Box>
                                <Box width={"100%"}>
                                  <CustomInput
                                    style={{
                                      background: "#F2F4F7  !important",
                                      pointerEvents: "none",
                                    }}
                                    disabled={true}
                                    placeholder={"Agreement Value"}
                                    value={eachUnit?.BSPTotal}
                                  />
                                </Box>
                              </Box>
                            </Box>
                            <Box className={cssClasses.SecondDiv} mb={2}>

                              <Box className={cssClasses.inputWrap}>
                                <Box className={cssClasses.InputTitle}>SDR</Box>
                                <Box width={"100%"}>
                                  <CustomInput
                                    style={{
                                      background: "#F2F4F7  !important",
                                      pointerEvents: "none",
                                    }}
                                    disabled={true}
                                    placeholder={"SDR"}
                                    value={eachUnit?.SDR}
                                  />
                                </Box>
                              </Box>

                              <Box className={cssClasses.inputWrap}>
                                <Box className={cssClasses.InputTitle}>GST</Box>
                                <Box width={"100%"}>
                                  <CustomInput
                                    style={{
                                      background: "#F2F4F7  !important",
                                      pointerEvents: "none",
                                    }}
                                    disabled={true}
                                    placeholder={"GST"}
                                    value={eachUnit?.GST}
                                  />
                                </Box>
                              </Box>

                              <Box className={cssClasses.inputWrap}>
                                <Box className={cssClasses.InputTitle}>Total</Box>
                                <Box width={"100%"}>
                                  <CustomInput
                                    style={{
                                      background: "#F2F4F7  !important",
                                      // pointerEvents: "none",
                                    }}
                                    // disabled={true}
                                    disabled={priceData[index].areaOptions[unitDataIndex].flag === false}
                                    placeholder={"Total"}
                                    value={eachUnit?.Total}
                                    inputType={"number"}
                                    handleChange={(_value) => {
                                      console.log("value", _value)
                                      if (priceData[index].areaOptions[unitDataIndex].flag === true) {
                                        setPriceData((pre) => {
                                          pre[index].areaOptions[unitDataIndex].Total = _value;
                                          return [...pre];
                                        });
                                        console.log("Total", _value)
                                        if (_value !== '') {
                                          // priceData[index].areaOptions[unitDataIndex].bspType === "Value";
                                          priceData[index].areaOptions[unitDataIndex].BSP = (parseInt(_value) / 1.08).toFixed(2); //*BSP
                                          if (_value >= 4500000) {
                                            priceData[index].areaOptions[unitDataIndex].GST =
                                              parseInt(priceData[index].areaOptions[unitDataIndex].BSP) * 0.05; //*GST
                                          } else {
                                            priceData[index].areaOptions[unitDataIndex].GST =
                                              parseInt(priceData[index].areaOptions[unitDataIndex].BSP) * 0.01; //*GST
                                          }
                                          priceData[index].areaOptions[unitDataIndex].REG = (parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07); //*REG
                                          priceData[index].areaOptions[unitDataIndex].SDR = (parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) * 0.07).toFixed(2); //*SDR
                                          //  priceData[index].UnitData.OCR = 100000;
                                          //  priceData[index].UnitData.SDR = 500000 - 100000 - parseInt(priceData[index]?.UnitData?.GST);
                                          //  const AllTotal = parseInt(priceData[index]?.UnitData?.OCR) + parseInt(priceData[index]?.UnitData?.SDR) + parseInt(priceData[index]?.UnitData?.GST)
                                          priceData[index].areaOptions[unitDataIndex].BSPTotal = parseFloat(
                                            priceData[index].areaOptions[unitDataIndex].BSP).toFixed(2); //*BSP-Total
                                          const AllTotal = parseInt(priceData[index].areaOptions[unitDataIndex].BSPTotal) + parseInt(priceData[index].areaOptions[unitDataIndex].SDR) + parseInt(priceData[index].areaOptions[unitDataIndex].GST); //*Total

                                          //  priceData[index].areaOptions[unitDataIndex].Total = AllTotal;

                                          console.log("priceData", priceData);
                                          setPriceData([...priceData]);
                                        }
                                      }
                                    }}
                                  />
                                </Box>
                              </Box>


                              <Box className={cssClasses.inputWrap} mt={4}>
                                <Box width={'100%'}>
                                  <Box className={cssClasses.InputTitle} mt={0.5} mr={0.5}>Agreement Value</Box>
                                  <CustomSwitch checked={eachUnit?.flag}
                                    onChange={(e) => {
                                      priceData[index].areaOptions[unitDataIndex].flag = e.target.checked;
                                      if (priceData[index].areaOptions[unitDataIndex].flag === true) {
                                        setPriceData((pre) => {
                                          pre[index].areaOptions[unitDataIndex].bspType =
                                            "Value";
                                          return [...pre];
                                        });
                                      } else {
                                        setPriceData((pre) => {
                                          pre[index].areaOptions[unitDataIndex].bspType =
                                            '';
                                          return [...pre];
                                        });
                                      }
                                      setPriceData([...priceData]);
                                    }}
                                  />
                                  <Box className={cssClasses.InputTitle} mt={0.5} ml={0.5}>Total</Box>
                                </Box>
                              </Box>
                              <Box>
                              </Box>

                            </Box>
                            <Divider />
                          </>
                        ))}

                      </Box>
                    </Box>
                  ))}
                </>
              )}



              <UpdatePrice
                childLaunch={ProjectPricingData}
                setChildLaunch={setProjectPricingData}
                floors={floorsSelected}
              />
            </>
          </Box>
        </Box>

        <Box className={cssClasses.FooterDiv}>
          <Box className={cssClasses.flexRow}>
            <Box width={"fit-Content"} ml={"auto"}>
              <Button
                style={{
                  color: "#344054",
                  backgroundColor: "#ffffff",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                padding={"0.85rem 2.6rem"}
                btnName={"Cancel"}
                clicked={handleEmptyClose}
              />
            </Box>

            <Box width={"fit-Content"}>
              <Button
                style={{
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                }}
                disable={ModalType === "Edit" ? false : SaveData}
                padding={"0.85rem 3rem"}
                btnName={"Save"}
                clicked={OnSubmit}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddPriceList;


